module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic08.ed2e3c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic08.png
// module id = 542
// module chunks = 1